var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.676 17.92c-112.681 0-218.564 43.868-298.254 123.502s-123.502 185.573-123.502 298.198c0 112.681 43.868 218.564 123.502 298.254s185.573 123.558 298.254 123.558c112.681 0 218.564-43.868 298.254-123.558s123.502-185.573 123.502-298.254c0-112.681-43.868-218.564-123.502-298.198s-185.573-123.502-298.254-123.502zM503.676 817.036c-208.075 0-377.361-169.285-377.361-377.361s169.285-377.361 377.361-377.361c208.075 0 377.361 169.285 377.361 377.361s-169.285 377.361-377.361 377.361zM414.885 262.094c-5.688 0-11.376 2.164-15.705 6.493l-133.186 133.186c-8.657 8.657-8.657 22.725 0 31.382s22.725 8.657 31.382 0l117.481-117.481 295.063 295.063c8.657 8.657 22.725 8.657 31.382 0s8.657-22.725 0-31.382l-310.767-310.767c-4.356-4.356-10.044-6.493-15.705-6.493h0.055z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.3e3b23f7687236e70a3bfd9b5b5dcd4c.svg";
export { ForwardRef as ReactComponent };